import { Platform } from 'react-native';
import { proxy } from '../../../../globalVars/data';

type Tprops = {
  actions: 'lock' | 'unlock';
  stationApiID: string;
  currId: string;
}[];

// unlockBike é acionado tanto p/ travar quanto destravar nos lugares:
// 1 - Componente ReturnBikeAuto na B5_TimerAuto (devolver/travar)
// 2 - createOrder (destravar a bike p/ cartao de credito)
// 3 - Componente QrCodeScreen na B4D_QrCodePayment (destravar a bike p/ pix)

export const unlockBike = async (props: Tprops) => {
  console.log('UNLOCK BIKES', { props });
  const myHeaders = new Headers();
  myHeaders.append('Content-Type', 'application/json');

  const promises = props.map(async ({ currId, actions, stationApiID }) => {
    const raw = JSON.stringify({ actions });

    const requestOptions: RequestInit = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow',
    };

    const urlWeb = proxy + `http://200.234.207.52:8000/stations/`;
    const urlNative = `http://200.234.207.52:8000/stations/`;

    const condNative = Platform.OS === 'web' ? urlWeb : urlNative;

    const url = `${condNative}${stationApiID}/racks/${currId}`;
    console.log('lock/unlock bike', { url });
    try {
      const response = await fetch(url, requestOptions);
      const result_1 = await response.text();
      console.log(`Resultado para ${currId}:`, result_1);
      return result_1;
    } catch (error) {
      console.error(`Erro em ${currId}:`, error);
      throw error;
    }
  });

  const arrayRes = await Promise.all(promises);

  return arrayRes;
};
